import { createApp } from 'vue';
import App from './App.vue'
import { createRouter, createWebHistory, NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import VueGtag from 'vue-gtag'

import Index from './components/Index.vue'
import Form from './components/Form.vue'
import Confirm from './components/Confirm.vue'
import Thanks from './components/Thanks.vue'

let base = ''
if (process.env.NODE_ENV !== "local") {
  base = '/inquiry/'
}

const router = createRouter({
  history: createWebHistory(base),
  routes: [
    {
      path: '/',
      component: Index,
      children: [
        {
          path: '',
          component: Form,
          meta: {
            title: 'お問い合わせフォーム'
          },
        },
        {
          path: '/confirm',
          component: Confirm,
          meta: {
            title: 'お問い合わせ内容確認'
          }
        },
        {
          path: '/thanks',
          component: Thanks,
          meta: {
            title: 'お問い合わせ完了'
          }
        }
      ]
    }
  ],
  scrollBehavior () {
    return { left: 0, top: 0 }
  }
})

router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  const defaultTitle = 'Linkus(リンクス)';
  const pageTitle = to.meta.title ? `${defaultTitle} | ${to.meta.title}` : defaultTitle;
  document.title = pageTitle;
  next();
});

createApp(App).use(VueGtag, {
  config: {id: process.env.VUE_APP_GA_ID}
}).use(router).mount('#app')
